import React from "react";
import styled from "styled-components";
import InfoTooltip from "../common/InfoTooltip";

const Wrapper = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #ffffff;
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}px` : "unset")};
    height: 100%;
    min-width: 0;
    @media (max-width: 600px) {
        border-radius: 0;
        border-left: none;
        border-right: none;
        padding: 16px 14px;
    }
`;

const TitleBar = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 16px;
    flex-shrink: 0;
`;

const TitleText = styled.div`
    flex: 1 1 auto;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const ContentContainer = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;

    & > * {
        min-width: 0;
        min-height: 0;
    }
`;

const Hr = styled.hr`
    border: 0;
    border-top: 1px solid #e2e8f0;
    margin: 16px -24px 12px;
    @media (max-width: 600px) { margin: 16px -14px 12px; }
`;

const FooterContainer = styled.div`
    flex-shrink: 0;
`;

export default function CardShell({ title, tooltip, minHeight, footer, children }) {
    return (
        <Wrapper $minHeight={minHeight}>
            <TitleBar>
                <TitleText title={typeof title === "string" ? title : undefined}>
                    {title}
                </TitleText>
                {tooltip && <InfoTooltip text={tooltip} />}
            </TitleBar>
            <ContentContainer>{children}</ContentContainer>
            {footer && (
                <>
                    <Hr />
                    <FooterContainer>{footer}</FooterContainer>
                </>
            )}
        </Wrapper>
    );
}
